class FeaturedBrands {
  constructor() {
    this.items = document.querySelectorAll(".featured-brands--block")
    this.button = document.querySelector(".button--more-brands")
    this.defaultVisible = 8
    this.expanded = false

    if (this.button) {
      this.icon = this.button.querySelector("img")
      this.button.addEventListener("click", this.toggle.bind(this))
    }
  }

  toggle() {
    if (!this.expanded) {
      // Show all
      this.items.forEach((item) => item.classList.remove("no-show"))
      this.updateButtonText("View less brands")
      this.icon.classList.add("rotate")
      this.expanded = true
    } else {
      // Collapse back to 8
      this.items.forEach((item, index) => {
        index >= this.defaultVisible
          ? item.classList.add("no-show")
          : item.classList.remove("no-show")
      })
      this.updateButtonText("View more brands")
      this.icon.classList.remove("rotate")
      this.expanded = false
    }
  }

  updateButtonText(text) {
    const img = this.button.querySelector("img")
    this.button.innerHTML = `${text}`
    this.button.appendChild(img)
  }
}

const featuredBrands = new FeaturedBrands()
